import { API } from "@/lib/api";
import { characterFor } from "@/lib/avatarConfig";

// Each player's raider, fetched once per page load and shared by every
// picture that falls back to it (Avatar). primeRaider() updates it when you
// save a new raider, so your own picture follows straight away.
const cache = new Map(); // userId -> Promise<character>

// No time limit: a slow server must never swap in someone else's raider
// (Jack saw a stranger's raider for Alisha when a 1.5s limit ran out).
// A failed fetch isn't kept, so the next picture tries again.
export function raiderFor(userId) {
  if (!cache.has(userId)) {
    const p = fetch(`${API}/users/${userId}/avatar3d`)
      .then((r) => {
        if (!r.ok) throw new Error(`avatar3d ${r.status}`);
        return r.json();
      })
      .then((d) => characterFor(userId, d?.look))
      .catch(() => {
        cache.delete(userId);
        return { ...characterFor(userId), fallback: true };
      });
    cache.set(userId, p);
  }
  return cache.get(userId);
}

const listeners = new Set(); // (userId) => void

export function primeRaider(userId, saved) {
  if (!userId) return;
  cache.set(userId, Promise.resolve(characterFor(userId, saved)));
  listeners.forEach((fn) => fn(userId));
}

// Calls `fn(userId)` whenever primeRaider changes a raider; returns the unsubscribe.
export function onRaiderChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
